// client/src/utils/validationMessages.ts
export const FIELD_LABELS = {
  manufacturer: "Manufacturer",
  model: "Model",
  partNumber: "Part number",
  quantity: "Quantity",
  condition: "Condition",
  price: "Price",
  currency: "Currency",
  category: "Category",
  categories: "Categories",
  country: "Country",
  description: "Description",
} as const;

export const MSG = {
  required: (label: string) => `${label} is required`,
  oneOf: (label: string, allowed: readonly string[]) =>
    `${label} must be one of: ${allowed.join(", ")}`,
  minInt: (label: string, min: number) => `${label} must be an integer ≥ ${min}`,
  positive: (label: string) => `${label} must be > 0`,
  lenMax: (label: string, max: number) => `${label} must be at most ${max} characters`,
  lenRange: (label: string, min: number, max: number) =>
    `${label} must be ${min}–${max} characters`,
  atLeastOneOf: (labelA: string, labelB: string) =>
    `At least one must be provided: ${labelA} or ${labelB}`,
};

export type FieldName = keyof typeof FIELD_LABELS;
export type FieldErrorMap = Partial<Record<FieldName, string>>;

// utility to turn ['manufacturer','model','price'] → "Manufacturer, Model, Price"
export const humanizeFieldList = (fields: FieldName[]) =>
  fields.map((f) => FIELD_LABELS[f]).join(", ");
